import app from 'flarum/forum/app';
import EventPost from 'flarum/forum/components/EventPost';
import ItemList from 'flarum/common/utils/ItemList';
import Button from 'flarum/common/components/Button';
import Handler from '../Checkout/Handler';
import LogInModal from 'flarum/forum/components/LogInModal';

export default class PtvRequiresPayment extends EventPost {
  descriptionKey() {
    return 'blomstra-payments.forum.pay-to-view.description';
  }

  descriptionData() {
    return {};
  }

  icon() {
    return 'fas fa-shopping-cart';
  }

  checkout() {
    const discussion = this.attrs.post.discussion().id();
    const handler = new Handler('ptv', {
      discussion,
    });

    handler.checkout();
  }

  footerItems() {
    const items = new ItemList();

    if (!app.session?.user) {
      items.add(
        'payToView',
        <div className="Button Button--rounded" onclick={() => app.modal.show(LogInModal)}>
          {app.translator.trans('blomstra-payments.forum.pay-to-view.purchase-log-in')}
        </div>
      );
    } else if (this.attrs.post.discussion().blomstraPtvPaid()) {
      items.add(
        'payToView',
        <div className="Button Button--rounded disabled completed">
          {app.translator.trans('blomstra-payments.forum.pay-to-view.purchase-completed')}
        </div>
      );
    } else {
      items.add(
        'payToView',
        <Button onclick={() => this.checkout()} className="Button Button--rounded">
          {app.translator.trans('blomstra-payments.forum.pay-to-view.purchase-control')}
        </Button>
      );
    }

    return items;
  }
  actionItems() {
    return new ItemList();
  }
}
